import React from 'react';

import { NotificationManager } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

import ModalPortal from 'common/ModalPortal/ModalPortal';

const FullscreenPopup = props => {
  const {
    data: { children },
    id,
    title = '',
  } = props;

  const handleClose = React.useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <ModalPortal>
      <DefaultPopup
        className="bet-checker-absolute-window"
        headerTitle={title}
        onClose={handleClose}
      >
        {children}
      </DefaultPopup>
    </ModalPortal>
  );
};

export default FullscreenPopup;
